import React from 'react';

const IQ = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_130"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_130)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10H21V15H0V10Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 8H11V8.495C11 8.785 11.224 9 11.5 9C11.768 9 12 8.774 12 8.495V6.495C12 6.222 12.232 6 12.5 6C12.776 6 13 6.216 13 6.495V8H14.49C14.772 8 15 8.232 15 8.5C15 8.776 14.778 9 14.49 9H6.51C6.228 9 6 8.768 6 8.5C6 8.288 6.13 8.107 6.32 8.034C6.345 7.97 6.383 7.909 6.436 7.857L7.856 6.437C8.05 6.243 8.371 6.25 8.561 6.439C8.757 6.634 8.763 6.944 8.565 7.142L7.707 8H9V7.505C9 7.225 9.232 7 9.5 7C9.776 7 10 7.214 10 7.505V8Z"
        fill="#007B3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H21V5H0V0Z"
        fill="#D0091E"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default IQ;
